import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import { ProjectName, ProjectTitle } from './styles';
import { useMobileDevice } from '../../../global/useMobile';
import { ProjectModel } from '../../../mobx/models/project';
import ProjectIconAvatar from '../../projectIconAvatar';
import { ICON_COLORS, PROJECT_ICON_TYPE } from '../../../global/constants';
import { ROUTES } from '../../../routes/urls';
import { getProjectIdFromPath } from '../../../routes/routeHelpers';

interface ProjectNameInterface {
  item: ProjectModel;
  forceHover?: boolean;
}
const ProjectItem = observer(function ProjectItem(props: ProjectNameInterface) {
  const { item, forceHover = false } = props;
  //Other variable
  const history = useHistory();
  const location = useLocation();
  const isProject = !!item?.id && getProjectIdFromPath(location?.pathname) === item?.id;
  const isMobile = useMobileDevice();

  const onClickProject = useCallback(() => {
    rootStore.projectStore.setCurrentProject(item?.id);
    history.push(ROUTES.PROJECT_TASKS.replace(':id', item?.id || ''));
  }, [history, item?.id]);

  return (
    <>
      <ProjectName
        role='button'
        onClick={onClickProject}
        forceHover={forceHover}
        isActive={isProject}
        className={isProject ? 'active-navbar-item-menu ' : 'navbar-menu-name'}>
        <ProjectIconAvatar
          size={isMobile ? 24 : 20}
          type={item?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
          reference={item?.icon?.reference || ''}
          backgroundColor={ICON_COLORS[item?.icon?.color || 1]}
          projectName={item?.name}
          borderRadius={isMobile ? '6px' : '4px'}
          iconSize={isMobile ? 16 : 13}
          isClickable={false}
        />
        <ProjectTitle>{item?.name}</ProjectTitle>
      </ProjectName>
    </>
  );
});

export { ProjectItem };
